import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "./registerServiceWorker";
import store from "./store";
import notyMiddleware from "./plugins/noty-middleware";
import initProgress from "./plugins/progressbar";

//plugins
import NowUIKit from "./plugins/now-ui-kit";
import GlobalJsFunctions from "./plugins/globalJsFunctions";
import Maps from "./plugins/maps";

Vue.config.productionTip = false;
Vue.use(NowUIKit);
Vue.use(GlobalJsFunctions);
Vue.use(Maps);

/* BEGIN MIDDLEWARE */

initProgress(router);
notyMiddleware(router);

/* END MIDDLEWARE */

new Vue({
  store,
  router,
  render: h => h(App),
  //workaround routing in IE11
  //https://github.com/vuejs/vue-router/issues/1849
  created() {
    if (
      "-ms-scroll-limit" in document.documentElement.style &&
      "-ms-ime-align" in document.documentElement.style
    ) {
      // detect it's IE11
      window.addEventListener(
        "hashchange",
        event => {
          var currentPath = window.location.hash.slice(1);
          if (this.$route.path !== currentPath) {
            this.$router.push(currentPath);
          }
        },
        false
      );
    }
  }
}).$mount("#app");